import type { IntlShape } from 'react-intl'
import type { RegistryMeterFormHeader, RegistryMeterHeader } from './types'
import { MeterLocation } from '../enum'

export const registryMeterHeaders: RegistryMeterHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Mittari',
				description: 'Table column header for meter registry: Meter',
			}),
		key: 'meter',
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Huoneisto',
				description: 'Table column header for meter registry: Apartment',
			}),
		key: 'apartmentUUID',
		show: true,
		sortable: true,
		type: 'apartmentOptions',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tyyppi',
				description: 'Table column header for meter registry: Type',
			}),
		key: 'type',
		show: true,
		sortable: true,
		type: 'meterType',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sisäänlukutapa',
				description: 'Table column header for meter registry: Reading method',
			}),
		key: 'readingMethod',
		show: true,
		sortable: true,
		type: 'readingMethod',
	},
]

export const registryMeterFormHeaders: RegistryMeterFormHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Mittari',
				description: 'Meter',
			}),
		key: 'meter',
		type: 'text',
		show: true,
		editable: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sijainti',
				description: 'Location',
			}),
		key: 'location',
		type: 'locationOptions',
		show: true,
		editable: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Huoneisto',
				description: 'Apartment',
			}),
		key: 'apartmentUUID',
		type: 'apartmentOptions',
		show: true,
		editable: false,
		showKey: 'location',
		showValue: MeterLocation.APARTMENT,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tyyppi',
				description: 'Type',
			}),
		key: 'type',
		type: 'typeOptions',
		show: true,
		editable: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sisäänlukutapa',
				description: 'Reading method',
			}),
		key: 'readingMethod',
		type: 'readingMethodOptions',
		show: true,
		editable: true,
		optionsFormKey: 'type',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätieto',
				description: 'Additional information',
			}),
		key: 'additionalInfo',
		type: 'text',
		show: true,
		editable: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Alkulukema',
				description: 'Initial reading value',
			}),
		key: 'initialReadingValue',
		type: 'number',
		show: true,
		editable: false,
		hideOnEdit: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Alkulukeman päivämäärä',
				description: 'Initial reading date',
			}),
		key: 'initialReadingDate',
		type: 'date',
		show: true,
		editable: false,
		hideOnEdit: true,
	},
]

export const registryMeterApartmentsHeaders: RegistryMeterFormHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tyyppi',
				description: 'Type',
			}),
		key: 'type',
		type: 'typeOptions',
		show: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sisäänlukutapa',
				description: 'Reading method',
			}),
		key: 'readingMethod',
		type: 'readingMethodOptions',
		show: true,
		optionsFormKey: 'type',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tunnuksen etuliite',
				description: 'Prefix of the identifier',
			}),
		key: 'prefix',
		type: 'text',
		show: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tunnuksen loppuliite',
				description: 'Suffix of the identifier',
			}),
		key: 'suffix',
		type: 'text',
		show: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage:
					'Lisää uusi mittari huoneistolle, vaikka huoneistolta mittari jo löytyisikin',
				description: 'Add new meter to apartment even if it already has one',
			}),
		key: 'addNewMeterEvenIfExists',
		type: 'yesNoSwitch',
		show: true,
	},
]
